module.exports = __webpack_public_path__ + "img/cat-face.87290bb9.png";